import { debounce } from './common/debounce';
export class RevealOnScroll {
    constructor(win = window, doc = win.document) {
        this.win = win;
        this.doc = doc;
        this.triggersToElements = new Map();
    }
    activate() {
        const elements = Array.from(this.doc.querySelectorAll('[data-reveal-on-scroll]'))
            .map(element => element);
        this.onScroll(elements);
        if (elements.length > 0) {
            this.win.addEventListener('scroll', debounce(() => this.onScroll(elements)), false);
        }
    }
    onScroll(elements) {
        elements.forEach(element => {
            let triggerPosition = 0;
            if (element.previousElementSibling) {
                triggerPosition = element.previousElementSibling
                    .getBoundingClientRect().bottom;
            }
            else if (element.parentElement) {
                triggerPosition = element.parentElement
                    .getBoundingClientRect().top;
            }
            else {
                return;
            }
            const revealClass = element.dataset.revealOnScroll || 'reveal';
            if (triggerPosition <= 0) {
                element.classList.add(revealClass);
            }
            else {
                element.classList.remove(revealClass);
            }
        });
    }
}
